import React from "react";

const DocumentsSkeleton: React.FC = () => (
  <div className="bg-white rounded shadow overflow-x-auto animate-pulse">
    <table className="w-full">
      <thead className="bg-white border-b border-gray-200">
        <tr>
          {/* checkbox */}
          <th className="px-3 sm:px-6 py-3 w-12">
            <div className="h-4 w-4 bg-gray-200 rounded" />
          </th>
          {/* Name */}
          <th className="px-3 sm:px-6 py-3 text-left">
            <div className="h-3 bg-gray-200 rounded w-12" />
          </th>
          {/* Labels */}
          <th className="px-3 sm:px-6 py-3 text-left hidden md:table-cell">
            <div className="h-3 bg-gray-200 rounded w-14" />
          </th>
          {/* Owner */}
          <th className="px-3 sm:px-6 py-3 text-left hidden lg:table-cell">
            <div className="h-3 bg-gray-200 rounded w-12" />
          </th>
          {/* Pages */}
          <th className="px-3 sm:px-6 py-3 text-left hidden sm:table-cell">
            <div className="h-3 bg-gray-200 rounded w-10" />
          </th>
          {/* Created at */}
          <th className="px-3 sm:px-6 py-3 text-left">
            <div className="h-3 bg-gray-200 rounded w-20" />
          </th>
          {/* Actions */}
          <th className="px-3 sm:px-6 py-3 text-right">
            <div className="h-3 bg-gray-200 rounded w-14 ml-auto" />
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {[...Array(10)].map((_, i) => (
          <tr key={i}>
            <td className="px-3 sm:px-6 py-4">
              <div className="h-4 w-4 bg-gray-200 rounded" />
            </td>
            <td className="px-3 sm:px-6 py-4">
              <div className="h-4 bg-gray-200 rounded w-40" />
            </td>
            <td className="px-3 sm:px-6 py-4 hidden md:table-cell">
              <div className="h-4 bg-gray-200 rounded w-20" />
            </td>
            <td className="px-3 sm:px-6 py-4 hidden lg:table-cell">
              <div className="h-4 bg-gray-200 rounded w-24" />
            </td>
            <td className="px-3 sm:px-6 py-4 hidden sm:table-cell">
              <div className="h-4 bg-gray-200 rounded w-8" />
            </td>
            <td className="px-3 sm:px-6 py-4">
              <div className="h-4 bg-gray-200 rounded w-32" />
            </td>
            <td className="px-3 sm:px-6 py-4">
              <div className="flex gap-3 justify-end">
                <div className="h-4 w-4 bg-gray-200 rounded" />
                <div className="h-4 w-4 bg-gray-200 rounded" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DocumentsSkeleton;
